import { HAS_WINDOW } from '@eventbrite/feature-detection';
import { TicketsPageSize } from '../../models/ticketsPage';
import { CheckoutState } from '../../state';

export const getIsOnlyCheckoutFlow = ({ app }: CheckoutState) => {
    const ticketsPageSizeParam =
        app?.request?.params?.ticketsPageSize ||
        (HAS_WINDOW
            ? new URLSearchParams(window.location.search).get('ticketsPageSize')
            : null);

    return ticketsPageSizeParam === TicketsPageSize.onlyCheckout;
};
